import './Footer.less';

const footer = (() =>{
    
    
    
    const initSocialSwitcher = () => {
        let opener = document.querySelector('#js-socials-opener');
        let switcher = document.querySelector('#js-socials-switcher');
        
        document.addEventListener('click', e => {
            if(e.target !== opener){
                switcher.classList.remove('opened');
            } else {
                switcher.classList.toggle('opened');
            }
        });
    };
    
    initSocialSwitcher();
    
})();

export default footer;